import { SkeletonArea } from 'components/skeletonArea';
import classNames from 'classnames';
import { selectIsOpenCarrello } from 'features/carrello/carrelloSelectors';
import styles from './SkeletonSportTable.module.scss';
import { useTypedSelector } from 'lib/centralStore';
import useWindowSize from 'hooks/useWindowSize';

export const SkeletonSportTable = ({ className }: { className?: string }) => {
  const isOpen = useTypedSelector(selectIsOpenCarrello);
  const { isMobile } = useWindowSize();

  return (
    <div
      className={classNames(styles.skeleton, className, { [styles.noMargin]: isMobile || isOpen })}
      data-key="sport-skeleton"
    >
      <div className={styles.tabs}>
        <SkeletonArea height="3" className={styles.tab} />
        <SkeletonArea height="3" className={styles.tab} />
        <SkeletonArea height="3" className={styles.tab} />
        <SkeletonArea height="3" className={styles.tab} />
      </div>
      <div className={styles.headersContainer}>
        <SkeletonArea height={isMobile ? '' : '2.2'} className={styles.header} />
        <SkeletonArea height={isMobile ? '' : '2.2'} className={styles.header} />
        <SkeletonArea height={isMobile ? '' : '2.2'} className={styles.header} />
      </div>
      <SkeletonArea height={isMobile ? '10.9' : '6.4'} className={styles.row} />
      <SkeletonArea height={isMobile ? '10.9' : '6.4'} className={styles.row} />
      <SkeletonArea height={isMobile ? '10.9' : '6.4'} className={styles.row} />
      <SkeletonArea height={isMobile ? '10.9' : '6.4'} className={styles.row} />
    </div>
  );
};
